export enum PackageScheduleStatus {
  EXPIRED = 'EXPIRED',
  EARLY = 'EARLY',
  CURRENT = 'CURRENT',
  COMPLETE = 'COMPLETE',
  CANCELLED = 'CANCELLED',
  PROCESSING = 'PROCESSING',
  ORDERNOTREADY = 'ORDERNOTREADY',
}
